import { SerializedConstructor } from '@langchain/core/load/serializable';

import { get } from 'lodash-es';
import { useMemo } from 'react';

import { backendAuthType } from '@/utils/constants';

import {
  isSerializedConstructor,
  isSerializedSecret,
} from '../../../utils/serialized';
import { MODEL_SECRETS } from '../Playground.constants';

export function usePlaygroundIsLoginNeeded(
  secrets: Record<string, string>,
  manifests?: SerializedConstructor[]
): boolean {
  const isMissing = useMemo(() => {
    let isMissing = false;
    manifests?.forEach((manifest) => {
      JSON.stringify(manifest, (_, value) => {
        if (
          isSerializedConstructor(value) &&
          MODEL_SECRETS[value.id.join('/')] != null
        ) {
          // if there are any secrets already present -> ignore
          if (
            Object.keys(value.kwargs).some((kwarg) =>
              isSerializedSecret(value.kwargs[kwarg])
            )
          ) {
            return value;
          }

          // if the secret kwarg is missing –> injecting
          const requestedSecrets = MODEL_SECRETS[value.id.join('/')];
          for (const kwarg of Object.keys(requestedSecrets)) {
            isMissing ||= !get(value.kwargs, kwarg);
          }

          // if present & falsy -> injecting
          for (const key of Object.values(requestedSecrets)) {
            if (key === 'OPENAI_API_KEY' && secrets['AZURE_OPENAI_API_KEY']) {
              // If OpenAI, could be azure or regular
              continue;
            }
            isMissing ||= !secrets[key as string];
          }
        }

        return value;
      });
    });

    return isMissing;
  }, [manifests, secrets]);

  if (backendAuthType !== 'supabase') return false;
  return isMissing;
}
